<template>
  <div>
      <textarea :maxlength="maxlength" :class="{'ust-textstyle': isUSTWall || isSimple, 'textstyle' : !isTextareaHalf, 'textstyle-half' : isTextareaHalf}" v-show="showInputFlag" v-model="textData" ref="textData"
        @keyup="textDataKeyUp"
        @compositionstart="handleCompositionStart"
        @compositionend="handleCompositionEnd">
      </textarea>
      <pre :class="{'ust-textstyle': isUSTWall || isSimple, 'textstyle' : !isTextareaHalf, 'textstyle-half' : isTextareaHalf}" v-show="!showInputFlag">{{ textData }}</pre>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'commentArea',
  props: {
    isUSTWall: {
      type: Boolean,
      default: false
    },
    isSimple: {
      type: Boolean,
      default: false
    },
    isTextareaHalf: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      maxlength: (this.isUSTWall || this.isSimple) ? 375 : 420, // 最大字符数
      isComposing: false // 是否在输入法组合过程中
    }
  },
  computed: {
    ...mapState([
      'showInputFlag', 'textDataView'
    ]),
    textData: {
      get () {
        return this.textDataView
      },
      set (val) {
        return this.SET_TEXTDATA(val)
      }
    }
  },
  watch: {
    textData () {
      // if (this.isUSTWall) {
      //   let textdata = this.$refs.textData
      //   textdata.setAttribute('maxlength', 260)
      // }
    }
  },
  methods: {
    ...mapMutations(['SET_TEXTDATA']),
    handleCompositionStart () {
      this.isComposing = true
    },
    handleCompositionEnd (event) {
      this.isComposing = false
      this.$nextTick(() => {
        this.enforceLimits()
      })
    },
    textDataKeyUp () {
      // if (this.isUSTWall) {
      //   let obj = this.textData.split(/\n/g)
      //   if (obj.length - 1 > 3) {
      //     this.textData = this.textData.slice(0, this.textData.length - 1)
      //   }
      // }

      if (!this.isComposing) { // 只有非输入法状态才检查
        this.enforceLimits()
      }
    },
    enforceLimits () {
      if (!this.$refs.textData) return
      // 检查是否已经达到容量限制
      // 如果已经达到限制，截断超出的内容
      while (this.isContentOverflowing() && this.textData.length > 0) {
        // 移除最后一个字符
        this.$refs.textData.value = this.$refs.textData.value.slice(0, this.$refs.textData.value.length - 1)
        this.textData = this.$refs.textData.value
      }
    },
    isContentOverflowing () {
      // 检查文本高度是否超出
      const textarea = this.$refs.textData
      if (textarea) {
        const scrollHeight = textarea.scrollHeight
        const clientHeight = textarea.clientHeight
        // 如果scrollHeight大于clientHeight，说明内容超出了可视区域
        // console.log(scrollHeight, clientHeight)
        // console.log(textarea.selectionStart, textarea.selectionEnd)
        if (scrollHeight > clientHeight + 2) {
          return true
        }
      }
      return false
    }
  }
}
</script>
<style scoped>
.textstyle {
  width: 500px;
  height: 335px;
  font-size: 15px;
  color: #000000;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  background-color: #f3f3f2;
  padding: 20px;
  margin-top: 30px;
  resize: none;
  outline: none;
  text-align: left;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, Arial, 'Avenir', sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 17px;
}
.textstyle-half{
  width: 500px;
  height: 100px;
  font-size: 15px;
  color: #000000;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  background-color: #f3f3f2;
  padding: 10px;
  margin-top: 30px;
  resize: none;
  outline: none;
  text-align: left;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, Arial, 'Avenir', sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 16px;
}
.ust-textstyle{
  width: 1070px;
  height: 85px;
  margin-top: 5px;
  padding: 5px;
  line-height: 15px;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, Arial, 'Avenir', sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 14px;
}
pre {
  white-space: pre-wrap;       /* css-3 */
  white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
  white-space: -pre-wrap;      /* Opera 4-6 */
  white-space: -o-pre-wrap;    /* Opera 7 */
  word-wrap: break-word;       /* Internet Explorer 5.5+ */
  word-break:break-all;
  overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/result/commentArea.vue